/*
This constants file holds the list of steps in the FAOB user journey
- label: what the user sees
- value: the cosmos contanier name if that step has a container
- route: faob routing 

Note: items with no cosmos container (metadata, checkout) won't show in the Model Card
*/
export const STEPS = [
  { number: 1, label: "Metadata", route: "metadata" },
  { number: 2, label: "Import", value: "importConfig", route: "import" },
  {
    number: 3,
    label: "Regime Parameters",
    value: "regimeParams",
    route: "regime-param",
  },
  {
    number: 4,
    label: "Regime Cells",
    value: "regimeConfig",
    route: "regime-config",
  },
  { number: 5, label: "Tuition", value: "scenario", route: "tuition" },
  {
    number: 6,
    label: "Awarding Strategy",
    value: "awardingStrategy",
    route: "awarding-strategy",
  },
  { number: 7, label: "Checkout", route: "checkout" },
];
